export default __webpack_public_path__ + "static/media/img-header.6c404d24.png";